import { Icon } from 'antd';
import * as React from 'react';
const LockSvg = (props:any) => (<svg {...props}
  viewBox="0 0 104 104">
  <g id="Unauthorized" stroke="none" fill="none">
      <g id="No-Access" transform="translate(-631.000000, -277.000000)">
          <g id="Group-2" transform="translate(496.000000, 277.000000)">
              <g id="Group" transform="translate(135.000000, 0.000000)">
                  <circle id="Oval" fill="#F35A4E" cx="52" cy="52" r="52"></circle>
                  {// tslint:disable-next-line:max-line-length
                  <path d="M35.4768702,48.9148688 L36.5903188,48.9148688 L36.5903188,36.7713009 C36.5903188,23.6814809 67.9259418,23.8391895 67.9259418,36.7713009 L67.9259418,48.9148688 L69.1984544,48.9148688 C70.470967,48.9148688 71.5844156,50.0188296 71.5844156,51.280499 L71.5844156,74.6213829 C71.5844156,75.8830523 70.470967,76.987013 69.1984544,76.987013 L35.4768702,76.987013 C34.0452935,76.987013 33.0909091,75.8830523 33.0909091,74.6213829 L33.0909091,51.280499 C33.0909091,50.0188296 34.0452935,48.9148688 35.4768702,48.9148688 Z M52.3376623,55.6963419 C54.7236235,55.6963419 56.6323924,57.7465546 56.6323924,60.1121848 C56.6323924,61.6892715 55.837072,63.1086496 54.5645594,63.7394843 L54.5645594,69.7324139 L49.9517012,69.7324139 L49.9517012,63.7394843 C48.6791886,63.1086496 47.8838682,61.6892715 47.8838682,60.1121848 C47.8838682,57.7465546 49.7926371,55.6963419 52.3376623,55.6963419 Z M41.6803692,48.9148688 L62.9949555,48.9148688 L62.9949555,36.7713009 C62.9949555,32.9862927 55.0417516,32.0400406 52.3376623,32.0400406 C49.633573,32.0400406 41.6803692,32.9862927 41.6803692,36.7713009 L41.6803692,48.9148688 Z" id="Shape" fill="#FFFFFF"></path>
                  }</g>
          </g>
      </g>
  </g>
  </svg>);
const LockIcon = props => (
  <Icon  component={(innerProps) => {
    return LockSvg(Object.assign({}, innerProps, props));
  }}></Icon>
);

export default LockIcon;
